import { initialMetricsPublisher } from 'src/utils/metrics';

export const measureTimeSinceAccountPage = (markName: string) => {
  // set a performance mark for the end
  performance.mark(markName);

  // measure the time between accountPageLoaded and end mark, then send it to katal metrics
  try {
    const measure = performance.measure(
      'time-to-interact-with-operator-flow',
      'accountPageLoaded',
      markName,
    );
    const actionMetricsPublisher =
      initialMetricsPublisher.newChildActionPublisherForMethod('UserMetrics');
    actionMetricsPublisher?.publishCounterMonitor(
      'timeToInteractWithOperatorFlowFromAccountPage',
      measure?.duration,
    );

    // clear the marks
    performance.clearMarks();
  } catch (e) {
    console.error(e);
  }
};
